<template>
    <div>
        <div class="drawer-header">
           {{wallet.indent_id}} / {{getWalletReason}}
        <div class="header-action">
            <Tooltip class="item" effect="dark" content="content" placement="bottom"
            :disabled="!disableSubmit">
            <div>
            <Button type="primary" size="small"
              @click="updateWallet"
              :disabled="disableSubmit"
              v-if="showSubmitButton && currentTab === 'DETAILS'">
            <span>{{ $t('WALLET_SUBMIT') }}</span>
            </Button>
            </div>
            <div slot="content" class="tooltipcontent">
              {{ $t('PAY_AMOUNT_COMMENT_REQUIRED') }}
            </div>
            </Tooltip>
        </div>
        </div>
      <div class="pill-body">
        <div class="pill-row tabsection">
      <Tabs @selectedTab="handleTabChange" :key="activeTab">
        <Tab :title="$t('DETAILS')" :active="currentTab === 'DETAILS'" v-if="activeTab === 'DETAILS'">
      <div v-if="wallet.comments">
        <h4 class="sub-head m-0 px-10" style="text-decoration: underline">{{$t('WALLET_SETTLED_LABEL')}}</h4>
        <div class="panel-head align-top mb-0 px-10">
          <p>{{$t('WALLET_SELLETMENT_COMMENT')}}: <strong>{{wallet.comments.message}}</strong></p>
          <p>{{$t('WALLET_SETTLED_BY')}}: <strong>{{wallet.comments.user_name}}</strong></p>
          <p>{{$t('WALLET_SETTLED_AT')}}: <strong>{{formatDate(wallet.comments.created_at)}}</strong></p>
        </div>
      </div>
        <div class="mt-20 px-20" v-if="wallet.attachments.length">
          <div class="cardbox">
            <div class="cardbox-cardtitle">{{ $t('LR_ATTACHMENTS') }}</div>
            <div class="attachment-scroll">
              <Attachments
                :attachments="wallet.attachments"
                :disableUpload="true"
                :allowDelete="false"
                :showPreview='true'/>
            </div>
          </div>
        </div>
        <div class="drawer-collapse-scroll-outer">
          <Collapse class="collapse-slider" v-model="activeName">
              <CollapseItem
                v-for="(consignee, consigneeIdx) in walletConsigneeDetails"
                :key="consignee.name"
                :name="consigneeIdx">
                <template slot="title">
                  <div class ="flex-container">
                    {{consignee.name}}{{ consignee.reference_id ? ` - ${consignee.reference_id}` : '' }}
                    <div class="ml-auto mr-10">
                      <svgicon name="rupee" class="fill-stroke" width="11" height="11" :original="false"/>
                      {{consigneeWiseTotal[consignee.name]}}
                    </div>
                  </div>
                </template>
                <TableComment
                  :header="getHeader"
                  :materials="consignee.materials"
                  :isGenerated="isGenerated"
                  :mandatoryComment="mandatoryComment"
                  :showIcon="showSubmitButton"
                  :showReturnQty="hasMaterialLevelData"
                  :returnQtyEditable="false"
                  @updateValue="updateValue"
                  @updateComment="updateComment"/>
                <div class="row align-items-center mx-0 px-20 pl-0 mb-10">
                  <div class="col-7 grid-title resulttext">{{ $t('INDENT_RETURN_QUANTITY_TOTAL') }} <span class="hint-text">{{ $t('INDENT_PCS') }}</span></div>
                  <div class="col-5 resultvalue grid-count">
                    <span>{{ returnQuantity }}</span>
                  </div>
                </div>
                <div class="row align-items-center mx-0 px-20 pl-0">
                  <div class="col-7 grid-title resulttext">{{ $t('WALLET_TOTAL_AMOUNT')}}</div>
                  <div class="col-5 resultvalue grid-count">
                    <svgicon name="rupee" class="fill-stroke" width="11" height="11" :original="false"/>
                    <span>{{getTotalAmount}}</span>
                  </div>
                </div>
              </CollapseItem>
          </Collapse>
          <Collapse
            v-if="customFields && customFields.length"
            class="collapse-slider"
            v-model="walletCustomFields"
            accordion
          >
            <CollapseItem name="Wallet Custom Fields">
              <template slot="title">
                <div class ="flex-container">
                  {{ $t('WALLET_CUSTOM_FIELDS') }}
                </div>
              </template>
              <div class="mt-15">
                <table class="custom-fields-table">
                  <thead>
                    <tr>
                      <th> Field </th>
                      <th> Value </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(field, index) in customFields" :key="index">
                      <td v-if="walletCustomConfig.includes(field.label)">
                        {{ field.label }}
                        <span
                          v-if="field.required"
                          style="color: red;"
                        >
                          *
                        </span>
                      </td>
                      <td v-if="walletCustomConfig.includes(field.label)">
                        <span>
                          <template v-if="field.value">
                            <template v-if="field.type === FIELD_TYPES.DATE">
                              {{ formatDate(field.value) }}
                            </template>
                            <template v-else>
                              {{ field.value }}
                            </template>
                          </template>
                          <template v-else>
                            -
                          </template>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CollapseItem>
          </Collapse>
        </div>
        </Tab>
        <Tab :title="$t('REMARKS')" :active="currentTab === 'REMARKS'">
          <div class="tab-body" v-if="remarks && remarks.length">
                <PrimaryComments
                  :showRejected="false"
                  :comments="remarks"
                  :walletId="wallet.id"
                  :readOnly="true"
                />
              </div>
        </Tab>
        <Tab :title="$t('TIMELINE')" :active="currentTab === 'TIMELINE'">
          <div class="block timelineblock" v-if="formattedTimelines && formattedTimelines.length">
                <Timeline class="timeline-default timestamp-left mt-10">
                  <TimelineItem
                    v-for="(event, id) in formattedTimelines"
                    :key="id"
                    placement="top"
                    class="dot-purple"
                  >
                    <div class="el-timeline-item__timestamp is-top">
                      <span class="date">{{ event.date }}</span>
                      <span>{{ event.time }}</span>
                    </div>
                    <h4>{{ event.message }}</h4>
                    <p v-if="event.userName">{{ event.userName }}</p>
                  </TimelineItem>
                </Timeline>
              </div>
        </Tab>
      </Tabs>
        </div>
      </div>
    </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { FIELD_TYPES } from 'pando-constants';
import SecComments from '@common/components/SecComments';
import { mapGetters } from 'vuex';
import Attachments from '@common/components/Attachments';
import TableComment from '@common/components/TableComment';
import PrimaryComments from '@common/components/PrimaryComments';
import { WalletStatus, WalletReason, commentParty, movementMapLower, WalletReasonMap, attachmentParentType, WalletHeader, WalletStatusList } from 'pando-constants';

export default {
  props: {
    wallet: {
      type: Object,
      default: () => {},
    },
    walletConfig: {
      type: Object,
      default: () => {},
    },
    activeTab: {
      type: String,
      default: 'DETAILS',
    },
    remarks: {
      type: Array,
      default: () => [],
    },
    timelines: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SecComments,
    Attachments,
    TableComment,
    PrimaryComments,
  },
  data() {
    return {
      walletConsigneeDetails: [],
      comments: [],
      amountChanged: false,
      activeName: null,
      WalletReasonMap,
      disableSubmit: true,
      changedCharges: {},
      hasMaterialComment: {},
      consigneeCharge: {},
      mandatoryComment: {},
      returnQuantity: 0,
      walletCustomFields: null,
      customFields: [],
      FIELD_TYPES,
      walletCustomConfig: [],
      currentTab: this.activeTab,
    };
  },
  async created() {
    this.constructConsigneeDetails();
    this.activeName = this.isTransitDelay && this.wallet.delivery_type === 'FTL' ? 0 : null;
    this.returnQuantity = this.wallet.return_quantity || 0;
    if (this.$hasFeature('wallet_custom_fields')) {
      await this.getWalletCustomFields();
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'app/currentUser', currentClientConfig: 'app/currentClientConfig' }),
    hasMaterialLevelData() {
      return this.$hasFeature('wallet_epod_material_data');
    },
    getWalletReason() {
      return this.WalletReasonMap[this.wallet.reason];
    },
    allowAttachmentUpload() {
      return (this.wallet.status !== WalletStatus.ACCEPTED)
      && (this.wallet.status !== WalletStatus.SETTLED);
    },
    // TODO: client config to be added
    showSubmitButton() {
      return this.wallet.status === WalletStatus.GENERATED;
    },
    allComments() {
      const comments = [...this.wallet.comments, ...this.comments];
      // fixing Build issue while nesting terinary operator
      // return comments.sort((a, b) => ((a.created_at > b.created_at) ? 1 : ((b.created_at > a.created_at) ? -1 : 0)));
      return comments.sort((a, b) => {
        let num;
        if (a.created_at > b.created_at) {
          num = 1;
        } else if (b.created_at > a.created_at) {
          num = -1;
        } else {
          num = 0;
        }
        return num;
      });
    },
    getHeader() {
      const reason = this.wallet.reason;
      return WalletHeader[WalletReasonMap[reason]];
    },
    isDisputed() {
      return this.wallet.status === WalletStatus.DISPUTED;
    },
    isGenerated() {
      return this.wallet.status === WalletStatus.GENERATED;
    },
    isTransitDelay() {
      return this.wallet.reason === WalletReason.TRANSIT_DELAY;
    },
    validReason() {
      return [WalletReason.REJECTION_PENALTY, WalletReason.ACCEPTANCE_SLA_BREACH_RE_ASSIGNED,
        WalletReason.SLA_BREACH, WalletReason.SLA_BREACH_RE_ASSIGNED, WalletReason.RFQ_DEBIT,
        WalletReason.OPEN_DEBIT, WalletReason.CONTRACT_REINDENT, WalletReason.DEDUCTIBLES,
        WalletReason.RECONCILE,
        WalletReason.TEMPERATURE_COMPLIANCE_PENALTY].includes(this.wallet.reason);
    },
    WalletTotal() {
      return this.walletConsigneeDetails.reduce((acc, consignee) => {
        if (consignee.materials && consignee.materials.length) {
          acc.shipper_amount += consignee.materials.reduce(
            ((_acc, material) => _acc + Number.parseFloat(material.shipper_amount) || 0), 0);
          acc.system_amount += consignee.materials.reduce(
            ((_acc, material) => _acc + Number.parseFloat(material.system_amount) || 0), 0);
          acc.transporter_amount += consignee.materials.reduce(
            ((_acc, material) => _acc + Number.parseFloat(material.transporter_amount) || 0), 0);
        }
        return acc;
      }, {
        shipper_amount: 0,
        transporter_amount: 0,
        system_amount: 0,
      });
    },
    getTotalAmount() {
      let totalAmount = 0;
      Object.values(this.consigneeCharge).forEach((charge) => { totalAmount += charge; });
      return totalAmount.toFixed(2);
    },
    consigneeWiseTotal() {
      const key = this.isDisputed ? 'transporter_amount' : 'shipper_amount';
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.consigneeCharge = this.walletConsigneeDetails.reduce((acc, consignee) => {
        if (consignee.materials && consignee.materials.length) {
          acc[consignee.name] = consignee.materials.reduce(
            ((_acc, material) => _acc + Number.parseFloat(material[key]) || 0), 0);
        } else {
          acc[consignee.name] = 0;
        }
        return acc;
      }, {});
      return this.consigneeCharge;
    },
    isApprovalRequired() {
      const currentWalletConfig = this.walletConfig
      && this.walletConfig[movementMapLower[this.wallet.movement]];
      const condition = (currentWalletConfig && currentWalletConfig.is_approval_required);
      return condition;
    },
    formattedTimelines() {
      if (!this.timelines || !this.timelines.length) return [];
      return this.timelines.map((timeline) => {
        const walletStatusName = WalletStatusList.find(s => s.id === timeline.status);
        return {
          date: this.$moment(timeline.created_at).format('DD MMM YYYY'),
          time: this.$moment(timeline.created_at).format('hh:mm A'),
          message: `Wallet ${walletStatusName ? walletStatusName.display : timeline.status}`,
          userName: timeline.user_email ? `${walletStatusName ? walletStatusName.display : timeline.status} by: ${timeline.user_email}` : null,
        };
      });
    },
  },
  methods: {
    handleTabChange(index) {
      const tabs = this.activeTab === 'DETAILS' ? ['DETAILS', 'REMARKS', 'TIMELINE'] : ['REMARKS', 'TIMELINE'];
      this.currentTab = tabs[index] || this.activeTab;
    },
    mandateComment() {
      return (this.currentClientConfig && this.currentClientConfig.payment_settings
        && this.currentClientConfig.payment_settings.mandate_wallet_comment) || false;
    },
    allowSubmit() {
      const isCommentMandatory = this.mandateComment();
      const changedCharges = Object.keys(this.changedCharges);
      let enableSubmit = (changedCharges.length > 0);
      if (isCommentMandatory) {
        changedCharges.forEach((id) => {
          this.mandatoryComment[id] = this.changedCharges[id] === '' || !this.hasMaterialComment[id];
          if (this.mandatoryComment[id]) {
            enableSubmit = false;
          }
        });
      }
      this.mandatoryComment = { ...this.mandatoryComment };
      this.disableSubmit = !enableSubmit;
    },
    updateValue(key, index, value) {
      this[key][index] = value;
      this.allowSubmit();
    },
    updateComment(materialId) {
      this.hasMaterialComment[materialId] = true;
      this.allowSubmit();
    },
    addAttachments(file) {
      const attachmentDetails = {};
      if (this.wallet.reason === WalletReason.TRANSIT_DELAY) {
        attachmentDetails.parent_id = this.wallet.id;
        attachmentDetails.parent_type = attachmentParentType.WALLET;
      } else {
        const firstConsignee = this.wallet.consignee_data
          && this.wallet.consignee_data[0];
        const firstMaterial = firstConsignee && firstConsignee.materials
        && firstConsignee.materials[0];
        attachmentDetails.parent_id = firstMaterial.id;
        attachmentDetails.parent_type = attachmentParentType.WALLET_CONSIGNEE_DATA;
      }
      this.$emit('addAttachments', file, attachmentDetails);
    },
    removeAttachments(file) {
      this.$emit('removeAttachments', file);
    },
    getTextClass(material) {
      return ((material.shipper_amount !== material.system_amount)
      || (material.transporter_amount !== material.system_amount)) && 'gridrefvalue primarycolor';
    },
    updateWallet() {
      const deliveryType = this.wallet.delivery_type;
      let payload;
      if ((this.isTransitDelay && deliveryType === 'FTL') || this.validReason) {
        payload = {
          status: WalletStatus.DISPUTED,
          wallet_id: this.wallet.id,
          consignee_data: [{
            destination_location_id: this.walletConsigneeDetails[0].id,
            amount: this.walletConsigneeDetails[0].materials[0].transporter_amount,
          }],
        };
      } else {
        payload = {
          status: WalletStatus.DISPUTED,
          wallet_id: this.wallet.id,
        };
        payload.consignee_data = this.walletConsigneeDetails.map(consignee => ({
          destination_location_id: consignee.id,
          ...(this.isTransitDelay ? { amount: consignee.materials[0].transporter_amount } : {}),
          ...(!this.isTransitDelay ? { materials: consignee.materials.map(material => ({
            amount: material.transporter_amount,
            material_code: material.material_code,
            id: material.id,
          })),
          } : {}),
        }));
      }
      this.$emit('updateAmount', payload);
    },
    computeAmountChanged() {
      this.amountChanged = false;
      const deliveryType = this.wallet.delivery_type;
      if (this.isTransitDelay && deliveryType === 'FTL') {
        const currentValue = this.walletConsigneeDetails[0].materials[0].transporter_amount;
        const prevValue = this.wallet.transporter_amount;
        if (currentValue < 0) {
          this.walletConsigneeDetails[0].materials[0].transporter_amount = 0;
        }
        if (currentValue !== prevValue) {
          this.amountChanged = true;
        }
      } else {
        for (let i = 0; i < this.walletConsigneeDetails.length; i += 1) {
          const currentConsignee = this.walletConsigneeDetails[i];
          const walletConsignee = this.wallet && this.wallet.consignee_data[i];
          if (currentConsignee && walletConsignee) {
            if (walletConsignee.materials) {
              for (let j = 0; j < currentConsignee.materials.length; j += 1) {
                const currMaterial = currentConsignee.materials[j];
                const prevValue = walletConsignee.materials[currMaterial.material_code]
                                          && walletConsignee.materials[currMaterial.material_code]
                                            .transporter_amount;
                if (currMaterial.transporter_amount < 0) {
                  currMaterial.transporter_amount = 0;
                }
                if (currMaterial.transporter_amount !== prevValue) {
                  this.amountChanged = true;
                }
              }
            } else if (walletConsignee.transporter_amount ||
            walletConsignee.transporter_amount === 0) {
              if (currentConsignee.materials[0].transporter_amount
              !== walletConsignee.transporter_amount) {
                this.amountChanged = true;
              }
            }
          }
        }
      }
    },
    addComments(message) {
      this.comments = [...this.comments, {
        message,
        party: commentParty.TRANSPORTER,
        created_at: new Date(),
        user_name: this.currentUser.name || this.currentUser.email,
      }];
    },
    constructConsigneeDetails() {
      if (this.wallet && this.wallet.consignee_data) {
        this.walletConsigneeDetails = this.wallet.consignee_data.map((consignee) => {
          const result = { ...consignee };
          if (this.isTransitDelay) {
            result.materials = [{
              delay_days: consignee.days,
              shipper_amount: consignee.shipper_amount,
              system_amount: consignee.system_amount,
              transporter_amount: consignee.transporter_amount,
              id: consignee.wallet_consignee_id,
              comments: consignee.comments,
              referenceId: consignee.reference_id,
            }];
          } else if (consignee.materials && consignee.materials.length) {
            result.materials = consignee.materials.map(material => ({
              material_code: material.material_code,
              shipper_amount: material.shipper_amount,
              transporter_amount: material.transporter_amount,
              system_amount: material.system_amount,
              id: material.id,
              showValues: false,
              comments: material.comments,
              epod_comment: material.epod_comment,
              return_quantity: material.return_quantity || 0,
            }));
          } else {
            result.materials = [{
              column_subtext: 'Debit Amount',
              shipper_amount: consignee.shipper_amount,
              system_amount: consignee.system_amount,
              transporter_amount: consignee.transporter_amount,
              id: consignee.wallet_consignee_id,
              comments: consignee.comments,
              return_quantity: consignee.return_quantity || 0,
            }];
          }
          result.materials.forEach((material) => {
            this.mandatoryComment[material.id] = false;
          });
          return result;
        });
      }
    },
    show(materialIndex, consigneeIdx) {
      const result = this.walletConsigneeDetails;
      result[consigneeIdx].materials[materialIndex].showValues =
      !result[consigneeIdx].materials[materialIndex].showValues;
      this.walletConsigneeDetails = result;
    },
    formatDate(date) {
      return date ? this.$moment(date).format('DD MMM YYYY hh:mm A') : null;
    },
    async getWalletCustomFields() {
      try {
        if (this.wallet) {
          const {
            data: { data: customFieldData = [], transporterFields } = {},
          } = await this.$store.dispatch('walletV2/getWalletCustomFields', {
            walletId: this.wallet.id,
          });
          this.walletCustomConfig = transporterFields;
          this.customFields = customFieldData;
        }
      } catch (error) {
        this.$errorMessage({ message: error.message || 'Failed to fetch wallet custom fields' });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
  .custom-fields-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    th, td {
      padding: 8px 12px;
      text-align: left;
      border: 1px solid #ddd;
    }
    th {
      background-color: #f5f5f5;
      font-weight: bold;
    }
  }
</style>
